/**
 * Generated bundle index. Do not edit.
 */

export * from './ckeditor.module';
